// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yQPg","toggle":"styles_toggle__1j75U","preview":"styles_preview__3_pLu"};